import React from 'react';
import { Flex } from '../../components/Flex';
import { Label, Paragraph } from '../../components/Text';
import { Gauge } from '../../components/Gauge';

const ShcGauge = ({
    type,
    total,
    values,
    loading
}) => {

    const gauge = {
        total: {
            title: "test results gauge",
            extra: "total fired",
            bars: [
                { key: "failed", color: "#E86565" },
                { key: "passed", color: "#6E9EEC" }
            ],
            emptyText: "No test were fired"
        },
        severity: {
            title: "results severity gauge",
            extra: "total failed",
            bars: [
                { key: "high", color: "#E86565" },
                { key: "medium", color: "#EE994A" },
                { key: "low", color: "#55C36D" },
                { key: "unk", color: "#9CA5B4" }
            ],
            emptyText: "No test were failed"
        }
    };

    return (
        <Flex flex={1} direction="column" gap={{ bottom: 4 }}>
            <Flex flex={1} justify="space-between">
                <Label bold>{gauge[type].title}</Label>
                <Flex align="center" gap={{ right: 4 }}>
                    <Label bold>{gauge[type].extra}:</Label>
                    <Paragraph size={"12px"}>{total}</Paragraph>
                </Flex>
            </Flex>
            <Gauge bars={gauge[type].bars} values={values} emptyText={gauge[type].emptyText} total={total} loading={loading} />
        </Flex>
    );
};

export { ShcGauge };